import React from "react";
import "./Pagination.css";
const Pagination = ({
  gotoPage,
  previousPage,
  nextPage,
  canNextPage,
  canPreviousPage,
  pageCount,
  pageIndex,
  pageOptions,
  pageSize,
  setPageSize,
  localData,
}) => {
  return (
    <div
      className="pagination"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div className="pagination-arrows">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </button>
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {"<"}
        </button>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {">"}
        </button>
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </button>
      </div>
      <div className="pagination-page-info">
        Page <strong>{pageIndex + 1} of {pageOptions.length}</strong>
      </div>
      <div className="pagination-page-size">
        <select
          value={pageSize === localData.length ? "all" : pageSize}
          onChange={(e) => {
            const value = e.target.value;
            setPageSize(value === "all" ? localData.length : Number(value));
          }}
        >
          {[10, 25, 50, 100].map((size) => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Pagination;
